import { useState, useEffect } from 'react';

import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

import iconArrowBack from 'assets/applebox/Icon_Arrow_Back.png'
import iconArrowReset from 'assets/applebox/Icon_Reset_Arrow.png'
import iconAvatar from 'assets/applebox/Icon_Avatar.png'
import imgBalanceBox from 'assets/applebox/AppBarBalanceBox.png'

import { makeStyles } from '@mui/styles';
import useAuth from 'hooks/useAuth';
import { jwtDecode } from 'jwt-decode';

const useStyles = makeStyles({
    changeBalanceBox: {
        padding: '5px 15px 5px 15px',
        borderRadius: '15px',
        position: "absolute",
        left: -10,
        right: -10,
        top: 0,
        bottom: 0,
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: 'rgba(0,0,0,0.75)',
        opacity: 0,
    },
    changeBalanceAni: {
        animation: "$movedown 2.5s ease forwards"
    },
    "@keyframes movedown": {
        "0%": {
            transform: "translateY(0)",
            opacity: 1
        },
        "25%": {
            transform: "translateY(30px)",
            opacity: 1
        },
        "75%": {
            transform: "translateY(30px)",
            opacity: 1
        },
        "100%": {
            transform: "translateY(40px)",
            opacity: 0
        }
    },
});

const ChangeBalanceBox = (props) => {
    const classes = useStyles();

    const [changed, setChanged] = useState("");
    const [prevBalance, setPrevBalance] = useState(null);
    const [className, setClassName] = useState(classes.changeBalanceBox);

    useEffect(() => {
        if (props.balance != prevBalance) {
            if (prevBalance != null) { 
              if (props.balance > prevBalance) setChanged(`+${Math.floor(props.balance - prevBalance).toLocaleString()}`);
              else if (props.balance < prevBalance) setChanged(`-${Math.floor(prevBalance - props.balance).toLocaleString()}`);
                if (props.balance != prevBalance) {
                    if (props.balance > prevBalance) // 증가할때는 3초 후에 표시해준다.
                    {
                        setTimeout(() => {
                            setClassName(`${classes.changeBalanceBox} ${classes.changeBalanceAni}`);
                        }, 3000);
                    }
                    else setClassName(`${classes.changeBalanceBox} ${classes.changeBalanceAni}`);
                }
            }
            setPrevBalance(props.balance);
        }
    }, [props.balance]);

    return (
        <Box className={className} onAnimationEnd={() => setClassName(classes.changeBalanceBox)}>
            <Typography fontSize={'14px'} fontWeight={700} textAlign={'center'} color={'#fff'} display={'inline'} noWrap>{changed}</Typography>
            <Typography ml={1} fontSize={'14px'} fontWeight={700} textAlign={'center'} color={'#fff'} display={'inline'}>XABT</Typography>
        </Box>
    );
}

const HeaderGame = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const { user } = useAuth();
    const [userIcon, setUserIcon] = useState();
    const matchDown400 = useMediaQuery(theme.breakpoints.down('400'));

    const onClickHome = () => {
        navigate("/");
    }

    const onClickLogin = () => {
        navigate("/login");
    }

    const onClickRegister = () => {
        navigate("/register");
    }

    useEffect(() => {
        if (user != null) setUserIcon(user.picture);
    }, [user]);

    return (
        <Box position="sticky" top={0} sx={{ zIndex: 99, width: '100%', background: '#1a1d2e', borderBottom: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <Box sx={{ m: '0 auto', maxWidth: '500px' }}>
                <Box sx={{ p: '5px 10px 7px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 1 }}>
                        <Box component={'img'} src={iconArrowBack} alt="menu" width={60} onClick={onClickHome} />
                    </Box>
                    {
                        user != null &&
                        <Box sx={{ width:matchDown400 ? '150px' : '200px', height:matchDown400 ? '42px' : '57px', backgroundImage: `url(${imgBalanceBox})`, backgroundSize: 'cover', display:'flex', justifyContent:'center', alignItems:'center' }}>
                            <Typography fontSize={matchDown400 ? '13px': '15px'} fontWeight={400} textAlign={'center'} color={'#fff'} display={'inline'}>{Math.floor(user.balance).toLocaleString()}</Typography>
                            <Typography ml={1} fontSize={matchDown400 ? '13px': '15px'} fontWeight={700} textAlign={'center'} color={'#fff'} display={'inline'}>XABT</Typography>
                            <Box sx={{width:'15%'}} />
                        </Box>
                    }
                    {
                    user != null &&
                        <Box sx={{width:'60px'}}>
                            <Box sx={{m: '0 auto', width: '36px' }}>
                                <Box component={'img'} src={userIcon ? userIcon : iconAvatar} referrerPolicy="no-referrer" alt="logo" sx={{ width: '36px', borderRadius: '20px' }} />
                            </Box>
                            <Typography fontSize={matchDown400 ? '10px' : '12px'} fontWeight={700} textAlign={'center'} color={'#757575'}>{user.appleboxid}</Typography>
                        </Box>
                    }
                </Box>
            </Box>
        </Box>
    );
};

export default HeaderGame;
